import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchSubClasses,
  fetchClasses,
  fetchTeachers,
  IClassParam,
  subClassesPath,
  updateClass,
  UPDATE_CLASS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import SubClassForm from "../../../templates/manager/SubClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === UPDATE_CLASS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(subClassesPath);
    }
  }, [history, dispatch, state.success_message]);

  React.useEffect(() => {
    dispatch(fetchSubClasses());
    dispatch(fetchTeachers());
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  const updateSubClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(updateClass(cls)));
    },
    [dispatch, peep],
  );

  const sub_class = state.sub_classes.filter(cls => cls.id === id)[0];

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.subClasses, to: subClassesPath }]}
        currentTitle={titles.editSubClass}
      />
      <SubClassForm
        title={titles.editSubClass}
        calling={calling}
        classes={state.classes}
        teachers={state.teachers}
        teacher_ids={state.teachers
          .filter(t => t.class_ids.indexOf(id) !== -1)
          .map(t => t.id)}
        sub_class={sub_class}
        upsertSubClass={updateSubClassFunc}
      />
    </div>
  );
};
